// src/services/s3Service.ts
import AWS from 'aws-sdk';

// AWS Configuration - IMPORTANT: Move these to environment variables in production!
const AWS_CONFIG = {
  region: "eu-west-1",
  accessKeyId: "AKIA5BZO4OTMT72IYUE6",
  secretAccessKey: "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",
};

// Initialize S3 instance
let s3Instance: AWS.S3 | null = null;

export const getS3Instance = (): AWS.S3 => {
  if (!s3Instance) {
    AWS.config.update(AWS_CONFIG);
    s3Instance = new AWS.S3({
      region: AWS_CONFIG.region,
      credentials: {
        accessKeyId: AWS_CONFIG.accessKeyId,
        secretAccessKey: AWS_CONFIG.secretAccessKey,
      },
    });
  }
  return s3Instance;
};

// Function to get signed URL for an image (expires in 1 hour)
export const getSignedImageUrl = async (
  key: string,
  bucket: string = 'products-services-media',
  expires: number = 3600 // 1 hour
): Promise<string> => {
  try {
    const s3 = getS3Instance();
    
    const params = {
      Bucket: bucket,
      Key: key,
      Expires: expires,
    };
    
    const url = await s3.getSignedUrlPromise('getObject', params);
    console.log('Generated signed URL for key:', key, 'URL:', url);
    return url;
  } catch (error) {
    console.error('Error generating signed URL:', error);
    throw error;
  }
};

// Function to get public URL (if bucket is public)
export const getPublicImageUrl = (key: string): string => {
  const cleanKey = key.startsWith('/') ? key.substring(1) : key;
  return `https://products-services-media.s3.eu-west-1.amazonaws.com/${cleanKey}`;
};

// Function to test if image exists and is accessible
export const testImageAccessibility = async (key: string): Promise<boolean> => {
  return new Promise((resolve) => {
    const img = new Image();
    const url = getPublicImageUrl(key);
    
    img.onload = () => {
      console.log('Image loaded successfully:', url);
      resolve(true);
    };
    
    img.onerror = () => {
      console.log('Image failed to load:', url);
      resolve(false);
    };
    
    img.src = url;
    
    // Timeout after 5 seconds
    setTimeout(() => {
      if (!img.complete) {
        console.log('Image load timeout:', url);
        resolve(false);
      }
    }, 5000);
  });
};

// Function to get best available image URL
export const getBestImageUrl = async (
  key: string,
  useSignedUrl: boolean = true
): Promise<string> => {
  try {
    // First try public URL if it's accessible
    const isPublicAccessible = await testImageAccessibility(key);
    
    if (isPublicAccessible) {
      return getPublicImageUrl(key);
    }
    
    // If public URL fails and we're allowed to use signed URLs
    if (useSignedUrl) {
      try {
        const signedUrl = await getSignedImageUrl(key);
        return signedUrl;
      } catch (signedError) {
        console.error('Failed to get signed URL:', signedError);
        // Fallback to public URL anyway
        return getPublicImageUrl(key);
      }
    }
    
    // Return public URL as last resort
    return getPublicImageUrl(key);
  } catch (error) {
    console.error('Error getting image URL:', error);
    // Default fallback image
    return '';
  }
};